import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import AppHeader from "../../Comp/AppHeader";
import castToTV from "../../Screens/PrivacyPolicy/assets/castToTv.svg";

export default function CastToTVPro() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
   <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Cast to TV Pro | Privacy Policy</title>
      </Helmet>
         <AppHeader name="privacy" indexSlide={0} />
      <nav className="flex flex-col items-center md:flex-row md:justify-center gap-3 pt-20">
        <img
          src={castToTV}
          alt="Cast to TV Pro"
          className="w-20 h-20 md:w-30 md:h-30"
        />
        <h1 className="mt-2 md:mt-5 font-bold text-3xl md:text-4xl text-gray-800 text-center">
          Cast to TV Pro
        </h1>
      </nav>
      <main>
        <div className="w-5/6 md:w-3/4 px-1 break-words md:px-0 m-auto text-gray-700 text-xl">
          <h1 className="mt-20 font-bold text-5xl text-gray-800">
            Privacy Policy
          </h1>
          <p className="mt-4 text-gray-500 text-base">Last Updated: March 20, 2026</p>

        

          {/* Table of Contents */}
          <div className="mt-10 bg-gray-50 border border-gray-200 rounded-xl p-6">
            
            <h2 className="font-bold text-2xl text-gray-800 mb-4">Overview of Privacy Policy</h2>
            <ol className="list-decimal list-inside space-y-2 text-blue-600 text-base">
              <li> <a href="#section-1" className="hover:underline">General Provisions</a></li>
              <li>
               
                <a href="#section-2" className="hover:underline">Information Collection</a>
                <ol className="list-disc list-inside ml-6 mt-1 space-y-1 text-blue-500 text-sm">
                  <li><a href="#section-2-1" className="hover:underline">Data You Provide</a></li>
                  <li><a href="#section-2-2" className="hover:underline">Media Access</a></li>
                  <li><a href="#section-2-3" className="hover:underline">Automatically Processed Data</a></li>
                </ol>
              </li>
              <li><a href="#section-3" className="hover:underline">Data Retention</a></li>
              <li>
                <a href="#section-4" className="hover:underline">Disclosure of Information</a>
                <ol className="list-disc list-inside ml-6 mt-1 space-y-1 text-blue-500 text-sm">
                  <li><a href="#section-4-1" className="hover:underline">Third-Party Service Providers</a></li>
                  <li><a href="#section-4-2" className="hover:underline">International Data Transfers</a></li>
                </ol>
              </li>
              <li>
                <a href="#section-5" className="hover:underline">Your Rights</a>
                <ol className="list-disc list-inside ml-6 mt-1 space-y-1 text-blue-500 text-sm">
                  <li><a href="#section-5-ca" className="hover:underline">California Privacy Rights (CCPA)</a></li>
                  <li><a href="#section-5-va" className="hover:underline">Virginia Privacy Rights (VCDPA)</a></li>
                  <li><a href="#section-5-security" className="hover:underline">Security</a></li>
                  <li><a href="#section-5-children" className="hover:underline">Children's Privacy</a></li>
                </ol>
              </li>
              <li><a href="#section-6" className="hover:underline">Privacy Policy Updates</a></li>
              <li><a href="#section-7" className="hover:underline">Contact Us</a></li>
            </ol>
          </div>

          {/* Section I - General Provisions */}
          <section id="section-1" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">I. GENERAL PROVISIONS</h2>
            <p className="mb-4">
              Please read this Privacy Policy carefully. It explains how your information may be processed when you use our app. By downloading, accessing, or using the App, you acknowledge that you have read and understood this Privacy Policy.
            </p>
            <p className="mb-4">
              At AppSpace Solutions with the developer account - Photo editor &amp; Video editor - Merger IO ("we," "our," or "us"), we respect our users' privacy. This Privacy Policy informs you on how we handle your information when you use our Cast to TV mobile application (referred to as "Our App" or "The App").
            </p>
            <p>
              Our App allows users to cast or mirror media content from their Android device to compatible TV devices over the same Wi-Fi network.
            </p>
          </section>

          {/* Section II - Information Collection */}
          <section id="section-2" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">II. INFORMATION COLLECTION</h2>

            <div id="section-2-1" className="ml-2 space-y-6">
              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">2.1 Data You Provide</h3>
                <p className="mb-4">
                  We do not require account registration to use the App. You may voluntarily provide information when you contact us via email for support requests or feedback.
                </p>
                <p className="mb-2">In such cases, we may receive:</p>
                <ul className="list-disc list-inside ml-4 space-y-1 mb-4">
                  <li>Your name</li>
                  <li>Your email address</li>
                  <li>The content of your message</li>
                </ul>
                <p className="mb-4">
                  We use this information solely to improve our services and respond to your inquiry.
                </p>
                <p>
                  If you choose to cast photos, videos, or audio files, or mirror any media content, the App accesses only the media files you select. We do not upload or store your media content on our servers. We do not have a server.
                </p>
              </div>

              <div id="section-2-2">
                <h3 className="font-semibold text-xl text-gray-800 mb-2">2.2 Media Access</h3>
                <p className="mb-2">
                  The App accesses photos, videos, audio, or screen content only when you actively choose to cast or screen mirror them.
                </p>
                <ul className="list-disc list-inside ml-4 space-y-1 mb-4">
                  <li>Media is streamed over your local Wi-Fi network.</li>
                  <li>We do not have any servers to upload, store, or monitor your media content.</li>
                </ul>
              </div>

              <div id="section-2-3">
                <h3 className="font-semibold text-xl text-gray-800 mb-2">2.3 Automatically Processed Data</h3>
                <p className="mb-2">
                  Certain technical information may be processed automatically for functionality, analytics, or advertising purposes when you use the App.
                </p>
                <p className="mb-2">This may include:</p>
                <ul className="list-disc list-inside ml-4 space-y-1 mb-4">
                  <li>Device model and OS (operating system) version</li>
                  <li>App version and usage data</li>
                  <li>Advertising ID</li>
                  <li>Local network information (to discover casting devices)</li>
                </ul>
                <p className="mb-4">
                  Casting occurs over your local Wi-Fi network. We do not monitor or store the content you stream.
                </p>
                <p className="mb-4">
                  If advertising or analytics services are integrated, they may collect device identifiers and usage information in accordance with their own privacy policies (mentioned below).
                </p>
                <p className="mb-2">We may use services such as:</p>
                <div className="ml-4 space-y-2 text-base">
                  <div>
                    <p className="font-medium text-gray-800">Google Play Services</p>
                    <p><a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Privacy &amp; Terms – Google</a></p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-800">AdMob</p>
                    <p><a href="https://support.google.com/admob/answer/6128543" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Google AdMob Help</a></p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-800">Google Analytics</p>
                    <p><a href="https://firebase.google.com/policies/analytics" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Google Analytics for Firebase Use Policy</a></p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-800">Firebase Crashlytics</p>
                    <p><a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Privacy and Security in Firebase</a></p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-800">Facebook Analytics</p>
                    <p><a href="https://www.facebook.com/privacy/explanation" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Facebook's Data Policy</a></p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-800">Vungle</p>
                    <p><a href="http://vungle.com/privacy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Privacy Policy - Vungle</a></p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-800">AdColony</p>
                    <p><a href="https://www.digitalturbine.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">AdColony Privacy Policy</a></p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-800">Unity</p>
                    <p><a href="https://unity.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Unity Privacy Policy Hub</a></p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-800">MoPub (Parent company- AppLovin)</p>
                    <p><a href="https://www.applovin.com/privacy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Privacy Policy Page</a></p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-800">Adjust</p>
                    <p><a href="https://www.adjust.com/terms/privacy-policy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Adjust's Terms &amp; Privacy Policy</a></p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-800">Tenjin.io (by Tenjin, Inc.)</p>
                    <p><a href="https://tenjin.com/privacy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Privacy Policy – Tenjin</a></p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-800">AppsFlyer</p>
                    <p><a href="https://www.appsflyer.com/legal/privacy-policy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Legal Privacy Policy</a></p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-800">IronSource (by IronSource Mobile Ltd.)</p>
                    <p><a href="https://developers.is.com/ironsource-mobile/air/ironsource-mobile-privacy-policy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">IronSource Mobile Privacy Policy</a></p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-800">Facebook Audience Network (by Facebook Inc.)</p>
                    <p><a href="https://developers.facebook.com/docs/audience-network/optimization/best-practices/an-policy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Meta Audience Network Policy</a></p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-800">HyprMx (by HyprMX Mobile LLC.)</p>
                    <p><a href="https://jungroup.com/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">HyprMX Ad Privacy Policy</a></p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-800">Pangle (by Bytedance Pte.Ltd.)</p>
                    <p><a href="https://ad.oceanengine.com/union/media/privacy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Pangle End User Data Privacy Policy</a></p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-800">Fyber (now Digital Turbine)</p>
                    <p><a href="https://www.digitalturbine.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Legal Privacy Policy</a></p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-800">Mintegral (by Mintegral International Ltd.)</p>
                    <p><a href="https://www.mintegral.com/en/privacy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Mintegral Privacy Policy</a></p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-800">Ogury (by Ogury Limited)</p>
                    <p><a href="https://ogury.com/ogury-advertising-privacy-policy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Ogury Advertising Privacy Policy</a></p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-800">Tapjoy (by Tapjoy Inc.)</p>
                    <p><a href="https://dev.tapjoy.com/en/legal/Advertiser-Terms-Of-Service" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Advertiser Terms of Service</a></p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-800">Chartboost (by LoopMe)</p>
                    <p><a href="https://docs.chartboost.com/en/legal/privacy-policy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Privacy Policy</a></p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-800">InMobi (by InMobi Pvt. Ltd.)</p>
                    <p><a href="https://advertising.inmobi.com/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">InMobi Advertising Privacy Policy</a></p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-800">Start.io (by Start.io Inc.)</p>
                    <p><a href="https://www.start.io/policy/privacy-policy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Start.io End User Privacy Policy</a></p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-800">Smaato (Part of Verve)</p>
                    <p><a href="https://www.smaato.com/privacy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Privacy Policy</a></p>
                  </div>
                  <div>
                    <p className="font-medium text-gray-800">Verizon (by Verizon Communication Inc.)</p>
                    <p><a href="https://www.verizon.com/about/privacy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Verizon's Privacy Policy</a></p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="mt-8">
               <h3 className="font-semibold text-xl text-gray-800 mb-2">Data Controller</h3>
              <p className="mb-4">
                Data Controller is the legal person or a group of people who decide what personal data is collected and how it will be used. For this Privacy Policy, we are the Data Controller of your Personal Data.
              </p>
            </div>

            {/* DPO */}
            <div className="mt-8">
              <h3 className="font-semibold text-xl text-gray-800 mb-2">Data Protection Officer (DPO)</h3>
              <p className="mb-4">
                We have appointed a Data Protection Officer (DPO) to oversee our data protection strategy and ensure our app complies with privacy regulations. The DPO is responsible for:
              </p>
              <ul className="list-disc list-inside ml-4 space-y-1 mb-4">
                <li>Monitoring compliance with data protection laws.</li>
                <li>Acting as a point of contact for data protection-related inquiries.</li>
                <li>Assisting users in exercising their data protection rights.</li>
              </ul>
              <p className="mb-2">If you have any questions about your privacy or would like to exercise any of your rights under applicable laws, please contact our DPO.</p>
              <p className="mb-1 font-bold">Contact Information for the DPO:</p>
              <p>
                Email:{" "}
                <a href="mailto:mergeriosolutions@gmail.com" className="text-blue-600 hover:underline">
                  mergeriosolutions@gmail.com
                </a>
              </p>
              <p>Contact No.: +91 8433400233</p>
            </div>
          </section>

          {/* Section III - Data Retention */}
          <section id="section-3" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">III. DATA RETENTION</h2>
            <p className="mb-4">
              We retain personal information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law.
            </p>
            <p className="mb-4">
              Our Cast to TV application does not store or retain user personal data on our servers (we do not have a server), except for limited information that may be voluntarily provided by users when contacting us.
            </p>
            <p className="mb-2">The only personal information we may retain is:</p>
            <ul className="list-disc list-inside ml-4 space-y-1 mb-4">
              <li>Name</li>
              <li>Email address</li>
            </ul>
            <p className="mb-4">
              This information is retained solely for the purpose of responding to user inquiries, providing customer support, or communicating regarding the use of our services.
            </p>
            <p className="mb-4">
              We retain this information only for as long as necessary to resolve the request or provide support, after which it is securely deleted or anonymized unless retention is required for legal, security, or administrative purposes.
            </p>
            <p>
              We do not retain or store casting activity, device media files, or screen mirroring content from users of the application.
            </p>
          </section>

          {/* Section IV - Disclosure of Information */}
          <section id="section-4" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">IV. DISCLOSURE OF INFORMATION</h2>

            <div id="section-4-1" className="ml-2 space-y-6">
              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">4.1 Third-Party Service Providers</h3>
                <p className="mb-2">We do not sell or rent your personal data.</p>
                <p className="mb-2">We may share limited technical information with trusted third-party providers for:</p>
                <ul className="list-disc list-inside ml-4 space-y-1 mb-4">
                  <li>Advertising</li>
                  <li>Analytics</li>
                  <li>Crash reporting</li>
                  <li>App functionality</li>
                </ul>
                <p>Such providers process data according to their own privacy policies and applicable laws.</p>
              </div>

              <div id="section-4-2">
                <h3 className="font-semibold text-xl text-gray-800 mb-2">4.2 International Data Transfers</h3>
                <p>
                  There is a chance that data may be processed in countries outside your own due to the global nature of third-party service providers. We take reasonable measures to ensure appropriate safeguards are applied to protect your data.
                </p>
              </div>
            </div>
          </section>

          {/* Section V - Your Rights */}
          <section id="section-5" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">V. YOUR RIGHTS</h2>

            {/* California */}
            <div id="section-5-ca" className="ml-2 space-y-6">
              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">California Privacy Rights (CCPA)</h3>
                <p className="mb-4">
                  If you are a California resident, you have specific rights regarding your personal information under the California Consumer Privacy Act (CCPA).
                </p>
                <p className="mb-2">These rights include:</p>

                <div className="ml-2 space-y-4">
                  <div>
                    <h4 className="font-semibold text-gray-800 mb-1">Right to Know</h4>
                    <p className="mb-2">
                      You have the right to request that we disclose certain information to you about our collection, use, and sharing of your personal information. Upon receiving and verifying your request, we will disclose:
                    </p>
                    <ul className="list-disc list-inside ml-4 space-y-1">
                      <li>The categories of personal information we collected about you</li>
                      <li>The categories of sources from which the personal information was collected</li>
                      <li>The business or commercial purpose for collecting or sharing personal information</li>
                      <li>The categories of third parties with whom we share personal information</li>
                      <li>The specific pieces of personal information we collected about you</li>
                    </ul>
                  </div>

                  <div>
                    <h4 className="font-semibold text-gray-800 mb-1">Right to Request Deletion</h4>
                    <p>You have the right to request that we delete any personal information we collected from you, subject to certain exceptions.</p>
                  </div>

                  <div>
                    <h4 className="font-semibold text-gray-800 mb-1">Right to Opt-Out of Sale or Sharing</h4>
                    <p>We do not share or sell your personal information. However, if we ever engage in activities that qualify as "selling" or "sharing" personal information under applicable laws, you will have the right to opt out.</p>
                  </div>

                  <div>
                    <h4 className="font-semibold text-gray-800 mb-1">Right to Non-Discrimination</h4>
                    <p>We will not discriminate against you for exercising any of your privacy rights.</p>
                  </div>

                  <div>
                    <h4 className="font-semibold text-gray-800 mb-1">How to Exercise Your Rights</h4>
                    <p className="mb-2">
                      To submit a request regarding your personal data or to know whether your personal information has been shared with third parties, you may contact us at:{" "}
                      <a href="mailto:feedback@appspacesolutions.in" className="text-blue-600 hover:underline">
                        feedback@appspacesolutions.in
                      </a>.
                    </p>
                    <p className="mb-2">We will verify your request before responding in accordance with applicable law.</p>
                    <p className="mb-2">Depending on your jurisdiction, you may have the right to:</p>
                    <ul className="list-disc list-inside ml-4 space-y-1 mb-4">
                      <li>Request information about the data we have collected about you</li>
                      <li>Request correction of inaccurate data</li>
                      <li>Request deletion of your data</li>
                      <li>Restrict or object to certain processing</li>
                      <li>Right to opt out of receiving personalized advertisements</li>
                      <li>Disable account tracking or data collection for analytics</li>
                    </ul>
                    <p>
                      To exercise your rights, please contact us using the details below.
                    </p>
                  </div>
                </div>
              </div>

              {/* Virginia */}
              <div id="section-5-va">
                <h3 className="font-semibold text-xl text-gray-800 mb-2">Virginia Privacy Rights (VCDPA)</h3>
                <p className="mb-4">
                  If you are a resident of Virginia, you are granted certain rights regarding your personal data under the Virginia Consumer Data Protection Act (VCDPA).
                </p>
                <p className="mb-4">These rights include the ability to opt out of certain uses of your personal data.</p>

                <div className="ml-2 space-y-4">
                  <div>
                    <h4 className="font-semibold text-gray-800 mb-1">Right to Opt-Out</h4>
                    <p className="mb-2">You have the right to opt out of:</p>
                    <ul className="list-disc list-inside ml-4 space-y-1">
                      <li>The processing of your personal data for targeted advertising</li>
                      <li>The sale of personal data</li>
                      <li>The use of your personal data for profiling in furtherance of decisions that produce legal or similarly significant effects</li>
                    </ul>
                  </div>

                  <div>
                    <h4 className="font-semibold text-gray-800 mb-1">How to Exercise Your Opt-Out Rights</h4>
                    <p className="mb-2">You may exercise your opt-out rights by:</p>
                    <ul className="list-disc list-inside ml-4 space-y-1 mb-4">
                      <li>Adjusting your device settings to limit ad tracking</li>
                      <li>Using the privacy or consent controls within the application (if available)</li>
                      <li>Contact us directly to request that your personal data not be used for targeted advertising or shared with third parties.</li>
                    </ul>
                    <p>
                      To submit an opt-out request, please contact us at:{" "}
                      <a href="mailto:feedback@appspacesolutions.in" className="text-blue-600 hover:underline">
                        feedback@appspacesolutions.in
                      </a>.
                    </p>
                    <p className="mt-2">We will respond to your request in accordance with applicable privacy laws.</p>
                  </div>
                </div>
              </div>

              {/* Security */}
              <div id="section-5-security">
                <h3 className="font-semibold text-xl text-gray-800 mb-2">5.1 Security</h3>
                <p>
                  We implement reasonable technical and organizational safeguards to protect information. However, no electronic transmission or storage system is completely secure.
                </p>
              </div>

              {/* Children's Privacy */}
              <div id="section-5-children">
                <h3 className="font-semibold text-xl text-gray-800 mb-2">5.2 Children's Privacy</h3>
                <p className="mb-4">
                  Our App is not directed to children under 13 (or the minimum age required by local law). We do not knowingly collect personal information from children.
                </p>
                <p>
                  If you believe a child has provided personal data, please contact us so we can take appropriate action.
                </p>
              </div>
            </div>
          </section>

          {/* Section VI - Privacy Policy Updates */}
          <section id="section-6" className="mt-12">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">VI. PRIVACY POLICY UPDATES</h2>
            <p>
              We may update this Privacy Policy from time to time. Any changes will be posted within the App or on the app store listing. Continued use of the App constitutes acceptance of the updated policy.
            </p>
          </section>

          {/* Section VII - Contact Us */}
          <section id="section-7" className="mt-12 mb-16">
            <h2 className="font-bold text-3xl text-gray-800 mb-4">VII. CONTACT US</h2>
            <p className="mb-2">If you have any questions regarding this Privacy Policy, please contact us:</p>
            <p className="font-semibold text-gray-800">AppSpace Solutions</p>
            <p>
              Email:{" "}
              <a href="mailto:feedback@appspacesolutions.in" className="text-blue-600 hover:underline">
                feedback@appspacesolutions.in
              </a>
            </p>
          </section>
        </div>
      </main>
    </>
  );
}